module.exports = __webpack_public_path__ + "storage-option-icon.png?dc505acbdb7b9436fbbf25995663930a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/storage-option-icon.png
// module id = 228
// module chunks = 0